import { PageCard, PageCardProps } from "@common/components/layout"
import { useApp } from "@common/hooks"
import { HospitalModel, HospitalScheduleTemplateListingModel } from "@common/models"
import { HospitalScheduleTemplateRequest } from "@common/models/requests/HospitalScheduleTemplateRequest"
import { HospitalScheduleTemplateSearchStore, HospitalScheduleTemplateStore } from "@hospital/stores"
import { observer } from "mobx-react"
import React from "react"
import { Button } from "react-bootstrap"
import { LocationScheduleTemplateModal } from "./LocationScheduleTemplateModal"
import { LocationScheduleTemplateTable } from "./LocationScheduleTemplateTable"

export type LocationScheduleTemplateDetailProps = {
    hospital: HospitalModel
} & PageCardProps

export const LocationScheduleTemplateDetail = observer(({ hospital, ...cardProps }: LocationScheduleTemplateDetailProps) => {
    const app = useApp();
    const [showModal, setShowModal] = React.useState(false);
    const [templateSearchStore] = React.useState(new HospitalScheduleTemplateSearchStore(app.configuration, { hospitalId: hospital.hospitalId }));
    const [templateStore] = React.useState(new HospitalScheduleTemplateStore());

    const onUpdateCreateSchedulePreference = (template?: HospitalScheduleTemplateListingModel) => {
        if (template && template.hospitalScheduleTemplateId > 0) {
            templateStore.loadHospitalScheduleTemplate(template.hospitalScheduleTemplateId).then(() => setShowModal(true));
        }
        else {
            templateStore.clearHospitalScheduleTemplate();
            setShowModal(true);
        }
    }

    const onSaveTemplate = (request: HospitalScheduleTemplateRequest) => {
        templateStore.saveHospitalScheduleTemplate(request).then(() => {
            setShowModal(false);
            templateSearchStore.search();
        });
    }

    React.useEffect(() => {
        templateSearchStore.search();
    }, [templateSearchStore, templateSearchStore.combinedSearchParams]);

    return (
        <>
            {!templateStore.isHospitalScheduleTemplateLoading && showModal && !templateSearchStore.isLoading &&
                <LocationScheduleTemplateModal hospitalScheduleTemplate={templateStore.hospitalScheduleTemplate}
                    show={showModal}
                    onClose={() => { setShowModal(false); templateStore.hospitalScheduleTemplate = undefined }}
                    onSaveTemplate={onSaveTemplate}
                    hospital={hospital}
                    existingTemplateNames={templateSearchStore.searchResults.results.map(p => p.name)}
                />
            }
            <PageCard title="Schedule Preferences" actionElement={
                <Button variant="primary" onClick={() => onUpdateCreateSchedulePreference()}>ADD NEW PREFERENCE</Button>
            } {...cardProps}>
                <LocationScheduleTemplateTable templateSearchStore={templateSearchStore} onUpdateCreateSchedulePreference={onUpdateCreateSchedulePreference} />
            </PageCard>
        </>
    )
})
